import React from 'react';
import { makeClassName } from '@siteless/util';
import { IconPropsType } from '../util/types';

const LetterboxdIcon = ({ className, ...rest }: IconPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
    className={makeClassName('LetterboxdIcon', className)}
  >
    <g transform="scale(0.9167) translate(1.09 1.09)">
      <circle cx="12" cy="12" r="11" fill="none" />
      <circle cx="7" cy="12" r="2" fill="none" />
      <circle cx="12" cy="12" r="2" fill="none" />
      <circle cx="17" cy="12" r="2" fill="none" />
    </g>
  </svg>
);

export default LetterboxdIcon;
